<template>
    <loader v-if="fetching">
    </loader>
    <!-- <div v-else-if="have_hotline">
    Show perm. tel
    </div> -->
    <tabs v-else
        :container-classes="[ 'panel', 'panel-transparent' ]"
        :nav-classes="['nav-tabs-fillup']"
        :store-module="moduleName"
        :key="customerId">
    </tabs>
</template>

<script type="text/babel">
    import Tabs from 'components/Tabs/Tabs'
    import Loader from 'views/Loader'
    import { moduleName } from 'components/Customer/tabs'
    import { resolveMutation, resolveState } from 'store/modules/tabs/tabManagerFactory'
    import routeWatcher from 'mixins/routeWatcher'
    import routeWatcherTab from 'mixins/routeWatcherTab'
    import { mapActions, mapMutations, mapState } from 'vuex'
    import { FETCHING_SWITCH } from 'store/mutation-types'

    export default {
        name: "Customer",

        mixins: [
            routeWatcher("fetchCustomerData"),
        ],

        props: {
            customerId: {
                type: Number,
                required: true,
            }
        },

        created() {
            this.fetchCustomerData()
                .then(() => this.activateTabRequestedInRoute())
        },

        watch: {
            $route (to, from) {
                if (!_.isNil(from))
                    this.fetchCustomerData()
                        .then(() => this.have_hotline)
            }
        },

        data () {
            return {
                moduleName,
                moduleState: resolveState('customer', this.$store.state),
                have_hotline:false,
            }
        },

        computed: {
            ...mapState('customer', ['fetching','contracts']),
            ...mapState(["customer"]),

        },

        methods: {
            ...mapActions('customer', [
                'fetchCustomer',
                'fetchAddresses',
                'fetchMainAddress',
                'fetchBillingAddress',
                'fetchRepresentatives',
                'fetchOrders',
                'fetchContracts',
                'fetchBrands',
                'fetchIntermediaryBusiness',
                'fetchSapOrganizations',
                "set_available_idxs"
            ]),

            ...mapMutations('customer', {
                fetchingSwitch: FETCHING_SWITCH
            }),

            fetchCustomerData () {
                this.fetchingSwitch()
                return this.fetchCustomer(this.customerId)
                    .then(() => Promise.all([
                        this.fetchSapOrganizations(),
                        this.fetchAddresses(),
                        this.fetchMainAddress(),
                        this.fetchBillingAddress(),
                        this.fetchOrders(),
                        this.fetchContracts({
                            search: "refused:0", 
                            with: "proxies.type;contract_options_all"
                        }),
                        this.fetchBrands(),
                        this.fetchRepresentatives(),
                        this.fetchIntermediaryBusiness()
                    ])
                        .then(this.fetchingSwitch)
                        .then(() => this.adaptTabsToCustomer())
                    )
            },

            adaptTabsToCustomer () {
                // console.log("fetchCustomerData after effect START")

                let tabsToRemove = []

                if (!this.customerIsEligibleToScan()) {
                    tabsToRemove.push('mail-scan')
                }
                if (!this.customerIsEligibleToHotline()) {
                    tabsToRemove.push('hotline')
                }
                if (!this.customer.profile.is_subject_to_beneficial_owners_declaration) {
                    tabsToRemove.push('beneficial-owners')
                }
                
                if (tabsToRemove.length > 0) {
                    // Getting indexes of tabs that have to be displayed
                    const tabsIndexes = []

                    _.forEach(this.moduleState.tabsArray, (tab) => {
                        if (tabsToRemove.indexOf(tab.name) === -1) {
                            tabsIndexes.push(_.indexOf(this.moduleState.tabsArray, tab))
                        }
                    })

                    this.set_available_idxs(tabsIndexes)
                } else {
                    this.set_available_idxs(null)
                }
                // console.log("fetchCustomerData after effect OVER")
            },

            activateTabRequestedInRoute() {
                const requestedTab = this.$route.params.tab

                if (undefined !== requestedTab) {
                    let filteredTabs = []
                    if (this.moduleState.available_tabs_indexes == null) {
                        filteredTabs = this.moduleState.tabsArray
                    } else {
                        filteredTabs = _.filter(this.moduleState.tabsArray, tab =>
                            _.find(this.moduleState.available_tabs_indexes, idx => _.indexOf(this.moduleState.tabsArray, tab) === idx) != undefined
                        )
                    }

                    const tabIndex = _.findIndex(filteredTabs, { name: requestedTab })
                    
                    if (tabIndex !== -1) {
                        this.$store.commit('tabs/customer/TAB_ACTIVATION', tabIndex)
                    } else {
                        this.$router.push({
                            name: 'customer',
                            params: { id: this.customerId }
                        })
                    }
                }
            },

            customerIsEligibleToScan() {
                let isEligible = false

                _.each(this.contracts, contract => {
                    _.each(contract.contract_options_all, opt => {
                        if (opt.option.mail_scan && _.includes(['active', 'pending-termination'], opt.status)) {
                            isEligible = true
                        }
                    })
                })

                return isEligible
            },

            customerIsEligibleToHotline() {
                let isEligible = false

                _.each(this.contracts, contract => {
                    _.each(contract.contract_options_all, opt => {
                        if (opt.option.simple_hotline && _.includes(['active', 'pending-termination'], opt.status)) {
                            isEligible = true
                        }
                    })
                })

                return isEligible
            }
        },

        components: {
            Tabs,
            Loader
        },
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// client/views/Customers/Customer.vue